<template>
  <div class="filters-and-actions">
    <div class="table-filters">
      <slot name="table-filters" />
    </div>
    <div class="table-actions">
      <slot name="table-actions" />
    </div>
  </div>
  <div class="row">
    <div
      :id="tableContainerId"
      class="col-12">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  interface ITableWrapperProps {
    id: string;
  }

  const props = defineProps<ITableWrapperProps>();

  const tableContainerId = computed(() => `${props.id}_table_container`);
</script>

<style scoped lang="scss">
  .filters-and-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .table-filters,
  .table-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;

    &:empty {
      margin-bottom: 0;
    }
  }

  .table-actions {
    flex-direction: row-reverse;
    gap: 1.2rem;
  }
</style>
